// redux/slices/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    updateProfileImage(state, action) {
      if (state.user) {
        state.user.profile_image = action.payload;
      }
    },
  },
});

export const { setUser, updateProfileImage } = userSlice.actions;
export default userSlice.reducer;
